export class UncontrolledTransactionModalPayload {
  transactionId: number;
}
